/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:no-magic-numbers

import { ContactDisplay, ContactRoleType, EmployeePayroll } from '@gh/builder-shared-data';
import { compact } from 'lodash';
import { nullate } from '@gh/core-util';
import { ContactDetailsCommon } from './resources/model/contact-details-common.model';
import { ContactDetailsEmployeeSalary } from './resources/model/contact-details-employee.model';

export function getContactName(common: ContactDetailsCommon): string {
  const { displayNameAs } = common;

  switch (common.type) {
    case ContactRoleType.Business:
      return common.businessName || '';
    case ContactRoleType.Individual:
      const { individualName } = common;
      if (individualName) {
        if (displayNameAs === ContactDisplay.FirstLastName) {
          return `${individualName.firstName || ''} ${individualName.lastName || ''}`.trim();
        } else {
          return `${individualName.lastName || ''} ${individualName.firstName || ''}`.trim();
        }
      }
      break;
    default:
      break;
  }

  return '';
}

export function getContactPhones(common: ContactDetailsCommon): string {
  return `${common.phone1 || ''} ${common.phone2 || ''}`.trim();
}

export function getContactAddress(common: ContactDetailsCommon): string {
  return compact([common.street1, common.street2, common.city, common.postcode]).join(' ');
}

export function getFullContactAddress(common: ContactDetailsCommon): string {
  return compact([common.street1, common.street2, common.city, common.state, common.postcode]).join(' ');
}

export function calculateHourlyRate(salary: ContactDetailsEmployeeSalary): number | null {
  if (!salary.salary || !salary.hoursInPayPeriod) {
    return nullate(void 0);
  }

  let hourlyRate = 0;
  switch (salary.payrollCycle) {
    case EmployeePayroll.Weekly:
      hourlyRate = salary.salary / (52 * salary.hoursInPayPeriod);
      break;
    case EmployeePayroll.Fortnightly:
      hourlyRate = salary.salary / (26 * salary.hoursInPayPeriod);
      break;
    case EmployeePayroll.FourWeekly:
      hourlyRate = salary.salary / (13 * salary.hoursInPayPeriod);
      break;
    case EmployeePayroll.Monthly:
      hourlyRate = salary.salary / (12 * salary.hoursInPayPeriod);
      break;
    default:
      break;
  }

  if (hourlyRate) {
    return hourlyRate;
  } else {
    return nullate(void 0);
  }
}
